import { Modal, useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import React, { useCallback, useState } from 'react'
import { useId } from '@react-aria/utils'
import { RatingsExtraFeedbackModalProps } from './Types'
import { RatingSegmentedControl } from 'components/RatingsExtraFeedbackDrawer/RatingSegmentedControl'
import { useUpdateFeedback } from 'hooks/queries/feedbacks/useUpdateFeedback'
import { FeedbackChips } from 'components/RatingsExtraFeedbackDrawer/FeedbackChips'
import { PressEvent } from '@react-types/shared/src/events'
import Styles from './RatingsExtraFeedbackModal.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { FeedbackTextField } from 'components/RatingsExtraFeedbackDrawer/FeedbackTextField'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { CheckBroken } from 'blaze-ui/icons'

export const RatingsExtraFeedbackModal = ({ feedback, ...modalProps }: RatingsExtraFeedbackModalProps) => {
  const { closeModal } = useModals()
  const id = useId()
  const [updatedFeedback, setUpdatedFeedback] = useState(feedback)
  let { mutate } = useUpdateFeedback(feedback.id, {
    onSettled: (data) => {
      data && setUpdatedFeedback(data)
    },
  })
  const [customFeedback, setCustomFeedback] = useState('')

  const handleFeedback = useCallback(
    (e: PressEvent) => {
      const feedback = e.target.getAttribute('data-key')

      if (!feedback) return

      mutate({
        feedback: {
          ...updatedFeedback.feedback,
          [feedback]: !updatedFeedback.feedback?.[feedback],
        },
      })
    },
    [mutate, updatedFeedback],
  )

  const handleSubmit = useCallback(() => {
    mutate({
      feedback: {
        ...updatedFeedback.feedback,
        feedback: customFeedback,
      },
    })
    showToastMessage('Your rating has been submitted', 'designRating', undefined, undefined, <CheckBroken size={24} />)
    closeModal()
  }, [customFeedback, updatedFeedback, mutate, closeModal])

  return (
    <Modal.Root aria-labelledby={id} {...modalProps}>
      <Modal.Header
        title="Thanks for your feedback"
        id={id}
        actions={
          <RatingSegmentedControl
            isFullWidth
            rounded
            variant="secondary"
            onItemClick={(item) => {
              mutate({
                rating: item as string,
              })
            }}
            activeItem={updatedFeedback.rating}
          />
        }
      />
      <Modal.Content>
        <div className={Styles.content}>
          {updatedFeedback.rating === 'downvote' && (
            <div className={Styles.feedback}>
              <Heading level={5}>What could be improved?</Heading>
              <div className={Styles.feedbacks}>
                <FeedbackChips onChipPress={handleFeedback} feedback={updatedFeedback} />
              </div>
            </div>
          )}
          <FeedbackTextField name="feedback" value={customFeedback} onChange={setCustomFeedback} />
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Button variant="secondary" size="lg" onPress={() => closeModal()}>
            Close
          </Button>
        </Modal.FooterContent>
        <Modal.FooterContent slot="right">
          <Button variant="primary" onPress={handleSubmit} size="lg">
            Submit Feedback
          </Button>
        </Modal.FooterContent>
      </Modal.Footer>
    </Modal.Root>
  )
}
